import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["id", "checked", "disabled", "name"];
import { computed } from 'vue';
import { tv } from 'tailwind-variants';
import clsx from 'clsx';
import { SpriteIcons } from '@/user/components/common/';
// eslint-disable-next-line vue/no-setup-props-destructure
export default /*@__PURE__*/ _defineComponent({
    __name: 'RadioButton',
    props: {
        id: {},
        name: {},
        label: {},
        checked: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        theme: { default: 'light' },
        className: { default: '' }
    },
    setup(__props) {
        const radiobutton = tv({
            variants: {
                part: {
                    container: 'group relative flex h-fit items-center gap-8 mb-4',
                    input: 'peer sr-only absolute',
                    defaultRadiobutton: 'peer-disabled:bg-gray-250 min-h-18 min-w-18 rounded-full border-1 border-gray-300 bg-white peer-checked:hidden peer-disabled:border-gray-300',
                    checkedIcon: 'pointer-events-none hidden h-18 max-h-18 w-18 min-w-18 peer-checked:block',
                    labelText: 'text-body-5 text-gray-800 group-hover:text-blue-700 peer-checked:font-semibold peer-checked:text-blue-700 peer-disabled:pointer-events-none peer-disabled:text-gray-400',
                },
                theme: {
                    light: '',
                    dark: '',
                },
            },
            compoundVariants: [
                {
                    theme: 'dark',
                    part: 'defaultRadiobutton',
                    class: 'border-white bg-gray-400/20 opacity-80 peer-disabled:border-gray-100 peer-disabled:bg-gray-600 peer-disabled:opacity-20',
                },
                {
                    theme: 'dark',
                    part: 'labelText',
                    class: 'text-gray-100 opacity-80 group-hover:text-white group-hover:opacity-100 peer-checked:text-white peer-checked:opacity-100 peer-disabled:text-gray-600 peer-disabled:opacity-50',
                },
            ],
        });
        const iconName = computed(() => (__props.theme === 'light' ? 'radio-checked' : 'radio-checked-dark'));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("label", {
                class: _normalizeClass(_unref(clsx)(_unref(radiobutton)({ part: 'container' }), __props.className))
            }, [
                _createElementVNode("input", {
                    id: __props.id,
                    checked: __props.checked,
                    class: _normalizeClass(_unref(radiobutton)({ part: 'input' })),
                    disabled: __props.disabled,
                    name: __props.name,
                    type: "radio"
                }, null, 10, _hoisted_1),
                _createElementVNode("span", {
                    "aria-hidden": "true",
                    class: _normalizeClass(_unref(radiobutton)({ part: 'defaultRadiobutton', theme: __props.theme }))
                }, null, 2),
                _createVNode(_unref(SpriteIcons), {
                    "aria-hidden": "true",
                    class: _normalizeClass(_unref(radiobutton)({ part: 'checkedIcon' })),
                    name: iconName.value
                }, null, 8, ["class", "name"]),
                _createElementVNode("span", {
                    class: _normalizeClass(_unref(clsx)(_unref(radiobutton)({ part: 'labelText', theme: __props.theme }), 'desktop:max-w-174 desktop:text-body-4'))
                }, _toDisplayString(__props.label), 3)
            ], 2));
        };
    }
});
